import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const SportsmanTeamMembershipContext = createContext<{
  params?: Routing.SportsmanTeamMembershipParams
}>({})

export { SportsmanTeamMembershipContext }
